import { render, staticRenderFns } from "./IdeaInitial.vue?vue&type=template&id=db565aa0&"
import script from "./IdeaInitial.vue?vue&type=script&lang=js&"
export * from "./IdeaInitial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports